var hisense = {
	name: "hisense",
	defaultCommandIndex: 1,
	commands: [
		{
			mode: "AC_MODE_OFF",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_NULL",
			command: [87,1,5,137,2,237,1,138,2,110,6,142,2,102,31,25,36,147,17,140,2,0,0,21,251,95,171,251,239,255,252,255,95,255,255,255,255,222,191,86,207,251,255,255,255,191,254,239,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,174,2,198,1,178,2,82,6,174,2,60,31,228,35,180,17,136,2,0,0,21,251,95,175,247,255,255,243,253,191,255,255,255,255,122,245,175,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,164,2,210,1,163,2,84,6,157,2,86,31,16,36,113,17,133,2,0,0,21,251,95,175,247,127,255,249,254,223,255,255,255,255,189,122,223,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,155,2,219,1,156,2,95,6,157,2,91,31,34,36,126,17,132,2,0,0,21,251,95,175,247,191,255,249,254,223,255,255,255,255,189,122,213,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,171,2,206,1,166,2,82,6,165,2,69,31,1,36,155,17,131,2,0,0,21,251,95,175,247,95,255,252,255,87,255,255,255,255,239,95,109,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,178,2,198,1,180,2,79,6,183,2,61,31,229,35,185,17,130,2,0,0,21,251,95,175,247,223,255,249,254,175,255,255,255,255,222,190,214,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,138,2,236,1,141,2,113,6,146,2,99,31,18,36,142,17,133,2,0,0,21,251,95,175,247,111,255,252,255,119,255,255,255,255,222,189,174,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,179,2,195,1,175,2,82,6,170,2,59,31,229,35,180,17,134,2,0,0,21,251,95,175,247,175,255,252,255,119,255,255,255,255,222,189,170,179,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,167,2,207,1,169,2,89,6,167,2,67,31,242,35,166,17,130,2,0,0,21,251,95,175,247,87,255,254,127,173,255,255,255,255,247,175,214,179,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,163,2,210,1,166,2,88,6,165,2,75,31,13,36,140,17,134,2,0,0,21,251,95,175,247,239,255,249,254,183,255,255,255,255,222,191,87,79,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,172,2,200,1,174,2,83,6,157,2,66,31,247,35,160,17,135,2,0,0,21,251,95,175,247,119,255,252,255,91,255,255,255,255,239,95,175,79,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,164,2,212,1,161,2,87,6,149,2,85,31,1,36,152,17,130,2,0,0,21,251,95,175,247,183,255,252,255,107,255,255,255,255,235,175,170,180,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,138,2,234,1,136,2,116,6,139,2,97,31,27,36,144,17,134,2,0,0,21,251,95,175,247,91,255,254,127,170,255,255,255,255,250,235,213,109,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,171,2,199,1,170,2,82,6,162,2,61,31,228,35,177,17,136,2,0,0,21,251,95,175,247,215,255,252,255,85,255,255,255,255,245,215,170,181,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,6,173,2,202,1,172,2,82,6,131,2,0,2,166,2,71,31,252,35,160,17,131,2,0,0,10,204,204,203,89,153,153,89,153,153,155,54,87,153,153,153,153,153,153,153,25,153,153,153,102,101,153,153,153,153,153,153,153,153,153,153,153,153,153,153,153,153,153,149,153,89,153,153,153,153,81,153,153,153,153,150,102,102,102,102,102,102,102,102,102,102,102,102,89,153,153,153,153,153,153,101,153,153],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,155,2,214,1,158,2,102,6,143,2,75,31,26,36,115,17,138,2,0,0,21,251,95,175,247,171,255,254,127,189,255,255,255,255,235,175,245,83,255,127,255,255,239,255,219,224],
		},
		/////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_LOW",
			command: [87,1,5,172,2,203,1,168,2,80,6,165,2,62,31,237,35,169,17,130,2,0,0,21,251,95,223,239,255,255,231,251,239,255,255,255,254,218,251,124,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [87,1,5,175,2,196,1,176,2,80,6,169,2,60,31,243,35,178,17,138,2,0,0,21,251,95,223,238,255,255,243,253,247,255,255,255,255,109,125,175,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [87,1,5,174,2,199,1,175,2,77,6,186,2,44,31,222,35,178,17,133,2,0,0,21,251,95,223,239,127,255,243,253,85,255,255,255,255,237,175,109,115,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [87,1,5,179,2,196,1,178,2,78,6,188,2,50,31,221,35,183,17,131,2,0,0,21,251,95,223,238,191,255,249,254,170,255,255,255,255,246,215,183,115,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [87,1,6,179,2,196,1,182,2,79,6,35,2,172,1,187,2,52,31,252,35,178,17,129,2,0,0,10,253,175,236,254,158,159,255,241,254,213,255,255,255,255,237,175,219,99,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [87,1,5,175,2,199,1,170,2,81,6,183,2,55,31,230,35,159,17,132,2,0,0,21,251,95,223,238,223,255,249,254,213,255,255,255,255,237,175,222,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [87,1,5,177,2,197,1,175,2,82,6,184,2,52,31,231,35,184,17,134,2,0,0,21,251,95,223,239,95,255,249,254,181,255,255,255,255,237,175,86,172,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [87,1,5,174,2,200,1,174,2,82,6,185,2,48,31,228,35,188,17,133,2,0,0,21,251,95,223,238,175,255,252,255,90,255,255,255,255,246,215,171,172,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [87,1,5,163,2,211,1,166,2,90,6,147,2,78,31,254,35,157,17,130,2,0,0,21,251,95,223,239,223,255,243,253,215,255,255,255,255,174,189,183,79,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [87,1,8,173,2,201,1,173,2,74,6,182,1,183,1,171,1,67,7,183,2,50,31,207,2,21,6,168,34,214,18,127,2,0,0,2,34,125,40,159,167,244,211,65,255,255,15,244,29,5,7,255,255,255,255,160,160,232,40,61,6,131,232,33,255,160,255,255,255,208,127,254,131,65,240],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [87,1,6,179,2,196,1,179,2,79,6,51,2,176,1,176,2,58,31,4,36,179,17,132,2,0,0,10,253,175,239,244,236,179,51,51,51,51,51,51,56,230,102,102,85,191,255,255,255,253,102,179,221,101,28,204,204,204,223,255,255,251,63,254,203,60],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [87,1,5,176,2,197,1,172,2,82,6,172,2,57,31,231,35,184,17,134,2,0,0,21,251,95,223,238,183,255,252,255,86,255,255,255,255,245,215,222,211,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [87,1,7,178,2,195,1,176,2,62,6,166,1,176,1,157,1,79,7,188,2,53,31,175,34,235,18,135,2,0,0,4,68,249,19,243,249,226,127,255,135,251,111,255,255,255,255,93,122,237,67,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [87,1,7,178,2,195,1,178,2,77,6,179,2,86,6,35,2,174,1,179,2,54,31,248,34,134,18,132,2,0,0,5,63,77,41,253,49,253,35,72,165,63,255,225,254,154,105,255,255,255,255,233,78,148,244,167,210,144,255,211,255,255,255,79,255,211,79,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [87,1,5,167,2,206,1,168,2,89,6,154,2,64,31,19,36,156,17,130,2,0,0,21,251,95,223,239,87,255,252,255,93,255,255,255,255,235,175,245,83,255,127,255,255,239,255,219,224],
		},
		/////////////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_MID",
			command: [87,1,5,135,2,234,1,137,2,111,6,140,2,98,31,236,35,148,17,152,2,0,0,21,251,95,191,239,255,255,231,250,247,255,255,255,255,109,127,124,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [87,1,5,139,2,232,1,137,2,117,6,148,2,83,31,34,36,118,17,135,2,0,0,21,251,95,191,238,255,255,243,253,187,255,255,255,255,171,95,107,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [87,1,5,139,2,235,1,136,2,117,6,142,2,98,31,13,36,141,17,132,2,0,0,21,251,95,191,239,127,255,243,253,93,255,255,255,255,213,175,91,115,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [87,1,5,137,2,233,1,140,2,118,6,140,2,101,31,16,36,139,17,136,2,0,0,21,251,95,191,238,191,255,249,254,174,255,255,255,255,234,215,173,92,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [87,1,5,135,2,235,1,137,2,118,6,141,2,95,31,250,35,148,17,136,2,0,0,21,251,95,191,239,191,255,243,253,93,255,255,255,255,213,175,91,179,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [87,1,5,140,2,236,1,140,2,121,6,139,2,104,31,8,36,146,17,130,2,0,0,21,251,95,191,238,223,255,249,254,237,255,255,255,255,213,175,213,179,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [87,1,5,142,2,233,1,137,2,115,6,155,2,92,31,48,36,108,17,132,2,0,0,21,251,95,191,239,95,255,249,254,237,255,255,255,255,213,175,214,179,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [87,1,5,139,2,236,1,139,2,120,6,144,2,93,31,16,36,133,17,131,2,0,0,21,251,95,191,238,175,255,252,255,91,127,255,255,255,245,107,218,171,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [87,1,5,135,2,236,1,140,2,116,6,133,2,97,31,16,36,152,17,136,2,0,0,21,251,95,191,239,223,255,243,253,109,255,255,255,255,213,175,107,211,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [87,1,5,138,2,238,1,136,2,114,6,129,2,91,31,0,36,142,17,127,2,0,0,21,251,95,191,238,239,255,249,254,182,255,255,255,255,234,215,181,116,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [87,1,5,136,2,238,1,138,2,118,6,148,2,87,31,44,36,124,17,131,2,0,0,21,251,95,191,239,111,255,249,254,214,255,255,255,255,234,215,213,180,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [87,1,5,137,2,234,1,137,2,111,6,149,2,80,31,41,36,108,17,139,2,0,0,21,251,95,191,238,183,255,252,255,107,127,255,255,255,245,107,234,173,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [87,1,5,139,2,235,1,143,2,112,6,147,2,87,31,50,36,97,17,131,2,0,0,21,251,95,191,239,175,255,249,254,171,127,255,255,255,245,107,213,117,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [87,1,5,139,2,234,1,138,2,112,6,159,2,79,31,61,36,91,17,136,2,0,0,21,251,95,191,238,215,255,252,255,85,191,255,255,255,250,181,234,173,79,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [87,1,5,138,2,235,1,138,2,113,6,141,2,90,31,55,36,112,17,136,2,0,0,21,251,95,191,239,87,255,252,255,85,191,255,255,255,250,181,234,181,79,253,255,255,255,191,255,111,128],
		},
		///////////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,172,2,203,1,173,2,83,6,167,2,69,31,231,35,185,17,131,2,0,0,21,251,95,255,223,255,255,207,247,239,255,255,255,253,213,245,87,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,162,2,209,1,165,2,93,6,160,2,65,31,226,35,151,17,133,2,0,0,21,251,95,255,221,255,255,231,250,170,255,255,255,255,238,175,123,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,137,2,235,1,141,2,117,6,146,2,103,31,1,36,151,17,135,2,0,0,21,251,95,255,222,255,255,231,250,170,255,255,255,255,238,175,125,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,166,2,204,1,168,2,89,6,156,2,79,31,0,36,163,17,138,2,0,0,21,251,95,255,221,127,255,243,253,85,127,255,255,255,247,87,189,115,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,165,2,205,1,168,2,88,6,166,2,64,31,239,35,173,17,137,2,0,0,21,251,95,255,223,127,255,231,251,85,255,255,255,255,221,95,251,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,172,2,198,1,176,2,84,6,182,2,60,31,234,35,162,17,139,2,0,0,21,251,95,255,221,191,255,243,253,106,255,255,255,255,238,175,93,179,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,162,2,210,1,162,2,94,6,153,2,80,31,0,36,151,17,138,2,0,0,21,251,95,255,222,191,255,243,253,213,255,255,255,255,221,95,122,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,143,2,230,1,142,2,110,6,154,2,90,31,64,36,95,17,133,2,0,0,21,251,95,255,221,95,255,249,254,234,255,255,255,255,238,175,186,179,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,136,2,236,1,139,2,117,6,149,2,87,31,30,36,144,17,135,2,0,0,21,251,95,255,223,191,255,231,250,181,255,255,255,255,221,94,223,79,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,136,2,238,1,140,2,115,6,143,2,90,31,74,36,92,17,130,2,0,0,21,251,95,255,221,223,255,243,253,90,255,255,255,255,238,175,109,211,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,135,2,236,1,143,2,110,6,157,2,75,31,43,36,123,17,135,2,0,0,21,251,95,255,222,223,255,243,253,181,255,255,255,255,221,95,187,79,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,161,2,210,1,164,2,93,6,141,2,78,31,249,35,163,17,135,2,0,0,21,251,95,255,221,111,255,249,254,218,255,255,255,255,238,175,218,211,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,162,2,211,1,166,2,91,6,152,2,74,31,245,35,161,17,132,2,0,0,21,251,95,255,223,95,255,243,253,117,255,255,255,255,213,175,253,79,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,170,2,205,1,168,2,87,6,158,2,66,31,12,36,166,17,131,2,0,0,21,251,95,255,221,175,255,249,254,186,255,255,255,255,234,215,251,83,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,140,2,231,1,137,2,111,6,134,2,97,31,12,36,141,17,140,2,0,0,21,251,95,255,222,175,255,249,254,245,255,255,255,255,213,175,125,83,255,127,255,255,239,255,219,224],
		},
		//////////////////////////HEAT////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,164,2,212,1,161,2,89,6,151,2,82,31,254,35,160,17,131,2,0,0,21,251,95,175,255,255,255,231,250,189,255,255,255,255,171,94,181,115,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,166,2,210,1,163,2,90,6,167,2,65,31,239,35,178,17,129,2,0,0,21,251,95,175,254,255,255,243,253,110,255,255,255,255,213,175,107,115,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,140,2,234,1,137,2,120,6,143,2,96,31,47,36,141,17,138,2,0,0,21,251,95,175,255,127,255,243,253,174,255,255,255,255,213,175,170,243,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,136,2,237,1,135,2,119,6,140,2,94,31,13,36,139,17,130,2,0,0,21,251,95,175,254,191,255,249,254,215,127,255,255,255,234,215,213,243,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,6,157,2,214,1,155,2,102,6,156,2,83,31,253,2,129,1,253,35,155,17,135,2,0,0,10,253,138,199,214,49,227,24,198,49,140,88,199,255,249,143,234,177,139,24,198,49,140,99,140,99,24,199,140,99,24,198,56,198,49,140,99,86,43,28,85,85,137,143,248,177,140,99,140,99,24,199,140,99,24,199,140,99,22,60,99,24,199,198,44,88,241],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,137,2,235,1,136,2,117,6,145,2,93,31,5,36,139,17,135,2,0,0,21,251,95,175,254,223,255,249,254,171,191,255,255,255,245,107,213,107,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,167,2,209,1,162,2,93,6,165,2,79,31,4,36,151,17,127,2,0,0,21,251,95,175,255,95,255,249,254,246,255,255,255,255,213,175,246,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,134,2,236,1,142,2,116,6,152,2,94,31,87,36,91,17,135,2,0,0,21,251,95,175,254,175,255,252,255,123,127,255,255,255,234,215,254,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,175,2,195,1,175,2,81,6,181,2,54,31,229,35,156,17,136,2,0,0,21,251,95,175,255,223,255,243,253,237,255,255,255,255,171,95,235,79,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,151,2,218,1,156,2,101,6,142,2,88,31,34,36,123,17,137,2,0,0,21,251,95,175,254,239,255,249,254,187,127,255,255,255,234,215,190,211,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,138,2,234,1,138,2,111,6,138,2,92,31,37,36,131,17,136,2,0,0,21,251,95,175,255,111,255,249,254,187,127,255,255,255,234,215,189,211,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,170,2,206,1,166,2,83,6,158,2,60,31,225,35,178,17,131,2,0,0,21,251,95,175,254,183,255,252,255,109,191,255,255,255,245,107,239,211,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,169,2,203,1,169,2,85,6,172,2,47,31,223,35,183,17,130,2,0,0,21,251,95,175,255,175,255,249,254,173,191,255,255,255,245,107,215,85,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,169,2,200,1,174,2,80,6,184,2,55,31,213,35,186,17,136,2,0,0,21,251,95,175,254,215,255,252,255,86,223,255,255,255,250,181,235,213,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,159,2,213,1,158,2,97,6,146,2,74,31,249,35,161,17,134,2,0,0,21,251,95,175,255,87,255,252,255,117,191,255,255,255,245,107,246,212,255,223,255,255,251,255,246,248],
		},
		//////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_LOW",
			command: [87,1,5,168,2,207,1,166,2,80,6,166,2,60,31,229,35,176,17,131,2,0,0,21,251,95,223,255,255,255,203,251,127,255,255,255,254,218,245,175,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [87,1,5,164,2,208,1,167,2,86,6,152,2,71,31,241,35,158,17,133,2,0,0,21,251,95,223,253,255,255,229,253,127,255,255,255,255,86,189,223,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [87,1,5,138,2,232,1,138,2,118,6,145,2,93,31,53,36,106,17,140,2,0,0,21,251,95,223,254,255,255,231,250,181,127,255,255,255,234,215,223,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [87,1,5,155,2,218,1,152,2,102,6,150,2,88,31,33,36,116,17,138,2,0,0,21,251,95,223,253,127,255,243,253,90,191,255,255,255,245,107,238,243,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [87,1,5,176,2,197,1,178,2,76,6,187,2,56,31,126,35,176,17,130,2,0,0,21,251,95,223,255,127,255,231,250,181,127,255,255,255,234,215,222,179,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [87,1,5,156,2,217,1,161,2,97,6,147,2,86,31,246,35,145,17,134,2,0,0,21,251,95,223,253,191,255,243,253,181,127,255,255,255,234,215,174,172,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [87,1,5,152,2,222,1,157,2,98,6,145,2,90,31,250,35,164,17,130,2,0,0,21,251,95,223,254,191,255,243,253,117,127,255,255,255,234,215,254,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [87,1,5,139,2,235,1,145,2,112,6,150,2,90,31,69,36,78,17,132,2,0,0,21,251,95,223,253,95,255,249,254,245,127,255,255,255,234,215,189,179,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [87,1,5,162,2,211,1,166,2,81,6,163,2,73,31,230,35,178,17,135,2,0,0,21,251,95,223,255,191,255,231,251,213,255,255,255,255,171,94,251,79,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [87,1,5,139,2,235,1,139,2,117,6,141,2,88,31,17,36,137,17,134,2,0,0,21,251,95,223,253,223,255,243,253,86,191,255,255,255,245,107,234,173,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [87,1,5,180,2,193,1,174,2,71,6,173,2,58,31,236,35,177,17,137,2,0,0,21,251,95,223,254,223,255,243,253,173,127,255,255,255,234,215,170,244,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [87,1,5,149,2,224,1,146,2,103,6,141,2,84,31,26,36,123,17,136,2,0,0,21,251,95,223,253,111,255,249,254,174,191,255,255,255,245,107,237,116,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [87,1,5,135,2,238,1,138,2,119,6,145,2,90,31,17,36,154,17,130,2,0,0,21,251,95,223,255,95,255,243,253,171,127,255,255,255,234,215,171,85,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [87,1,5,176,2,196,1,175,2,80,6,159,2,58,31,229,35,173,17,133,2,0,0,21,251,95,223,253,175,255,249,254,213,191,255,255,255,245,107,213,213,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [87,1,5,139,2,238,1,136,2,116,6,134,2,98,31,65,36,114,17,129,2,0,0,21,251,95,223,254,175,255,249,254,181,191,255,255,255,245,107,246,212,255,223,255,255,251,255,246,248],
		},
		////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_MID",
			command: [87,1,5,164,2,211,1,164,2,87,6,152,2,74,31,244,35,160,17,132,2,0,0,21,251,95,191,255,255,255,203,250,191,255,255,255,255,109,123,175,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [87,1,5,158,2,215,1,157,2,97,6,146,2,83,31,248,35,152,17,133,2,0,0,21,251,95,191,253,255,255,229,253,223,255,255,255,255,86,189,87,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [87,1,5,140,2,236,1,138,2,120,6,140,2,98,31,14,36,142,17,129,2,0,0,21,251,95,191,254,255,255,229,253,223,255,255,255,255,86,189,85,115,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [87,1,5,152,2,220,1,159,2,98,6,142,2,87,31,22,36,127,17,135,2,0,0,21,251,95,191,253,127,255,242,254,183,255,255,255,255,213,175,171,115,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [87,1,5,151,2,223,1,147,2,104,6,147,2,89,31,28,36,130,17,133,2,0,0,21,251,95,191,255,127,255,229,253,175,255,255,255,255,171,94,213,179,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [87,1,5,163,2,209,1,162,2,89,6,147,2,90,31,19,36,139,17,133,2,0,0,21,251,95,191,253,191,255,242,254,215,255,255,255,255,213,175,107,179,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [87,1,5,154,2,218,1,153,2,99,6,163,2,70,31,32,36,123,17,134,2,0,0,21,251,95,191,254,191,255,242,254,171,255,255,255,255,234,215,234,172,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [87,1,5,165,2,207,1,164,2,87,6,146,2,84,31,46,36,135,17,137,2,0,0,21,251,95,191,253,95,255,249,127,85,255,255,255,255,245,107,245,172,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [87,1,5,178,2,192,1,177,2,73,6,179,2,55,31,229,35,170,17,139,2,0,0,21,251,95,191,255,191,255,229,253,239,255,255,255,255,86,189,119,79,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [87,1,5,172,2,200,1,176,2,82,6,160,2,64,31,234,35,177,17,133,2,0,0,21,251,95,191,253,223,255,242,254,247,255,255,255,255,171,94,191,79,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [87,1,5,150,2,225,1,153,2,99,6,163,2,71,31,25,36,134,17,130,2,0,0,21,251,95,191,254,223,255,242,254,247,255,255,255,255,171,94,186,211,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [87,1,5,179,2,197,1,174,2,81,6,161,2,55,31,232,35,181,17,133,2,0,0,21,251,95,191,253,111,255,249,127,93,255,255,255,255,234,215,222,211,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [87,1,5,174,2,201,1,175,2,79,6,161,2,69,31,236,35,179,17,134,2,0,0,21,251,95,191,255,95,255,242,254,219,255,255,255,255,213,175,123,83,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [87,1,5,169,2,205,1,169,2,84,6,156,2,64,31,238,35,168,17,133,2,0,0,21,251,95,191,253,175,255,249,127,86,255,255,255,255,245,107,255,83,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [87,1,5,153,2,219,1,154,2,100,6,151,2,81,31,254,35,148,17,133,2,0,0,21,251,95,191,254,175,255,249,127,86,255,255,255,255,245,107,253,84,255,223,255,255,251,255,246,248],
		},
		//////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,141,2,232,1,137,2,100,6,141,2,84,31,222,35,170,17,153,2,0,0,21,251,95,255,255,255,255,151,247,175,255,255,255,254,218,245,252,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,140,2,236,1,140,2,102,6,138,2,100,31,235,35,179,17,155,2,0,0,21,251,95,255,251,255,255,203,250,173,255,255,255,255,219,95,171,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,138,2,237,1,143,2,115,6,140,2,105,31,253,35,171,17,147,2,0,0,21,251,95,255,253,255,255,203,250,173,255,255,255,255,219,95,173,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,141,2,233,1,143,2,117,6,143,2,98,31,17,36,142,17,135,2,0,0,21,251,95,255,250,255,255,229,253,173,255,255,255,255,219,94,213,115,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,142,2,234,1,139,2,112,6,162,2,78,31,6,36,155,17,132,2,0,0,21,251,95,255,254,255,255,203,251,91,255,255,255,255,182,189,174,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,146,2,225,1,152,2,110,6,146,2,83,31,33,36,119,17,138,2,0,0,21,251,95,255,251,127,255,229,253,109,255,255,255,255,219,95,85,179,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,136,2,236,1,138,2,115,6,144,2,100,31,20,36,135,17,135,2,0,0,21,251,95,255,253,127,255,229,253,219,255,255,255,255,182,189,86,179,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,176,2,197,1,175,2,78,6,188,2,50,31,225,35,180,17,131,2,0,0,21,251,95,255,250,191,255,242,254,237,255,255,255,255,219,94,170,172,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,172,2,201,1,174,2,85,6,161,2,62,31,237,35,178,17,135,2,0,0,21,251,95,255,255,127,255,203,250,187,255,255,255,255,182,191,189,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,156,2,217,1,154,2,99,6,160,2,72,31,27,36,132,17,136,2,0,0,21,251,95,255,251,191,255,229,253,187,255,255,255,255,182,189,215,79,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,171,2,202,1,172,2,87,6,165,2,62,31,254,35,181,17,132,2,0,0,21,251,95,255,253,191,255,229,253,187,255,255,255,255,182,189,219,79,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,135,2,237,1,137,2,116,6,144,2,84,31,7,36,142,17,133,2,0,0,21,251,95,255,250,223,255,242,254,221,255,255,255,255,219,94,234,211,255,127,255,255,239,255,219,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,173,2,202,1,171,2,84,6,171,2,65,31,241,35,173,17,130,2,0,0,21,251,95,255,254,191,255,229,253,85,255,255,255,255,234,215,182,212,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,137,2,236,1,138,2,118,6,155,2,82,31,56,36,122,17,133,2,0,0,21,251,95,255,251,95,255,242,254,170,255,255,255,255,245,107,219,212,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [87,1,5,137,2,234,1,137,2,115,6,149,2,90,31,24,36,136,17,136,2,0,0,21,251,95,255,253,95,255,242,254,170,255,255,255,255,245,107,219,85,63,247,255,255,254,255,253,190],
		},
		////////////////////////DRY//////////////////////////
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_DRY_N7",
			fan: "AC_FAN_NULL",
			command: [87,1,5,143,2,232,1,139,2,101,6,146,2,95,31,239,35,177,17,153,2,0,0,21,251,95,253,107,171,255,255,47,234,247,255,255,255,254,218,245,183,63,247,253,191,255,191,255,85,224],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_DRY_N6",
			fan: "AC_FAN_NULL",
			command: [87,1,5,142,2,231,1,137,2,114,6,147,2,93,31,233,35,190,17,150,2,0,0,21,251,95,253,107,171,255,255,47,237,239,255,255,255,253,90,245,183,63,247,255,127,255,127,254,215,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_DRY_N5",
			fan: "AC_FAN_NULL",
			command: [87,1,5,136,2,236,1,137,2,103,6,142,2,97,31,233,35,169,17,143,2,0,0,21,251,95,253,107,171,255,255,47,237,239,255,255,255,253,90,245,183,63,247,253,127,255,191,255,95,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_DRY_N4",
			fan: "AC_FAN_NULL",
			command: [87,1,5,139,2,235,1,139,2,103,6,136,2,103,31,5,36,174,17,153,2,0,0,21,251,95,253,107,171,255,255,47,235,239,255,255,255,253,90,254,220,255,223,251,255,253,255,251,248],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_DRY_N3",
			fan: "AC_FAN_NULL",
			command: [87,1,5,142,2,230,1,134,2,106,6,141,2,96,31,237,35,179,17,153,2,0,0,21,251,95,253,107,171,255,255,47,239,223,255,255,255,250,181,238,220,255,223,247,255,253,255,250,190],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_DRY_N2",
			fan: "AC_FAN_NULL",
			command: [87,1,5,174,2,202,1,173,2,83,6,175,2,61,31,230,35,179,17,130,2,0,0,21,251,95,253,107,171,255,255,47,234,171,255,255,255,255,171,95,91,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_DRY_N1",
			fan: "AC_FAN_NULL",
			command: [87,1,5,172,2,199,1,175,2,83,6,171,2,55,31,224,35,175,17,136,2,0,0,21,251,95,251,107,171,255,255,47,237,87,255,255,255,255,86,189,93,207,253,255,255,255,191,255,111,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_NULL",
			command: [87,1,5,152,2,223,1,146,2,113,6,172,2,74,31,45,36,113,17,131,2,0,0,21,251,95,255,174,175,255,252,191,173,95,255,255,255,253,90,253,171,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_DRY_1",
			fan: "AC_FAN_NULL",
			command: [87,1,5,141,2,231,1,137,2,107,6,139,2,99,31,0,36,146,17,148,2,0,0,21,251,95,251,215,87,255,254,95,214,175,255,255,255,254,173,126,235,63,247,255,255,254,255,253,190],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_DRY_2",
			fan: "AC_FAN_NULL",
			command: [87,1,5,162,2,212,1,164,2,95,6,149,2,89,31,0,36,160,17,136,2,0,0,21,251,95,253,215,87,255,254,95,221,95,255,255,255,253,181,251,108,255,223,255,255,251,255,246,248],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_DRY_3",
			fan: "AC_FAN_NULL",
			command: [87,1,5,139,2,236,1,124,2,118,6,138,2,101,31,10,36,139,17,131,2,0,0,21,251,95,253,215,87,255,254,95,221,95,255,255,255,253,181,251,108,255,223,247,255,253,255,250,190],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_DRY_4",
			fan: "AC_FAN_NULL",
			command: [87,1,5,165,2,208,1,169,2,88,6,160,2,73,31,0,36,162,17,133,2,0,0,21,251,95,253,215,87,255,254,95,213,175,255,255,255,254,218,245,219,63,247,254,255,255,127,254,254],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_DRY_5",
			fan: "AC_FAN_NULL",
			command: [87,1,5,159,2,217,1,152,2,95,6,167,2,77,31,7,36,130,17,132,2,0,0,21,251,95,253,215,87,255,254,95,213,175,255,255,255,254,218,245,219,63,247,253,127,255,191,255,95,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_DRY_6",
			fan: "AC_FAN_NULL",
			command: [87,1,5,160,2,211,1,156,2,96,6,157,2,80,31,6,36,150,17,134,2,0,0,21,251,95,253,215,87,255,254,95,219,95,255,255,255,253,181,247,108,255,223,253,255,253,255,251,94],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_DRY_7",
			fan: "AC_FAN_NULL",
			command: [87,1,5,138,2,235,1,131,2,118,6,148,2,88,31,4,36,118,17,131,2,0,0,21,251,95,253,215,87,255,254,95,219,95,255,255,255,253,181,247,108,255,223,246,255,254,255,253,87,128],
		},
		//////////////////////////////FAN//////////////////////////////
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_ULTRA_LOW",
			command: [87,1,5,165,2,209,1,155,2,90,6,170,2,74,31,7,36,156,17,131,2,0,0,21,251,95,175,251,87,255,254,127,175,255,255,255,255,234,183,190,179,254,247,255,255,247,255,221,120],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_LOW",
			command: [87,1,5,137,2,234,1,129,2,117,6,136,2,107,31,18,36,147,17,139,2,0,0,21,251,95,223,246,175,255,252,255,87,255,255,255,255,239,94,214,179,254,247,255,255,247,255,221,120],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_MID",
			command: [87,1,5,173,2,198,1,166,2,85,6,175,2,61,31,235,35,185,17,136,2,0,0,21,251,95,191,246,175,255,252,255,87,255,255,255,255,239,95,86,179,254,247,255,255,247,255,221,120],
		},
	]
}

export default hisense